import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import {
  GetAdminOrganizationsParams,
  ListAdminOrganizationsResponse,
  OrganizationStatsResponse,
  ShowAdminOrganizationResponse,
} from "./types";

export * from "./types";

const ENDPOINTS = {
  LIST: "/api/v2/admin/organizations",
  SHOW: "/api/v2/admin/organizations/:organization_id",
  STATS: "/api/v2/admin/organizations/:organization_id/stats",
};

export class AdminOrganizationsAPI {
  constructor(private client: CohesiveAPIClient) {}

  /**
   * List all organizations with stats and pagination (admin)
   */
  async list(
    params: GetAdminOrganizationsParams = {},
    config?: AxiosRequestConfig,
  ): Promise<ListAdminOrganizationsResponse> {
    const searchParams = new URLSearchParams();

    if (params.paying_orgs_only !== undefined)
      searchParams.append("paying_orgs_only", String(params.paying_orgs_only));
    if (params.search) searchParams.append("search", params.search);
    if (params.subscription_status)
      searchParams.append("subscription_status", params.subscription_status);
    if (params.plan_name) searchParams.append("plan_name", params.plan_name);
    if (params.limit) searchParams.append("limit", String(params.limit));
    if (params.offset) searchParams.append("offset", String(params.offset));

    const url = `${ENDPOINTS.LIST}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    const response =
      await this.client.axios.get<ListAdminOrganizationsResponse>(url, config);
    return response.data;
  }

  /**
   * Get single organization with stats (admin)
   */
  async get(
    organizationId: string,
    config?: AxiosRequestConfig,
  ): Promise<ShowAdminOrganizationResponse> {
    const url = ENDPOINTS.SHOW.replace(":organization_id", organizationId);
    const response = await this.client.axios.get<ShowAdminOrganizationResponse>(
      url,
      config,
    );
    return response.data;
  }

  /**
   * Get organization statistics (admin)
   */
  async getStats(
    organizationId: string,
    config?: AxiosRequestConfig,
  ): Promise<OrganizationStatsResponse> {
    const url = ENDPOINTS.STATS.replace(":organization_id", organizationId);
    const response = await this.client.axios.get<OrganizationStatsResponse>(
      url,
      config,
    );
    return response.data;
  }
}
